import React from 'react';
import constant from '@/utils/constant';

function OemFooter() {
  const isJXK = window.location.host.indexOf('fz.jinxiaoke.com') >= 0;
  return isJXK ? /*#__PURE__*/React.createElement("div", {
    style: {
      color: '#c7a7a7'
    }
  }, "\u91D1\u9500\u5BA2 \u24D2 Copyright JinXiaoKe 2019-2026 \xA0 \u5907\u6848\u53F7:\xA0", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://beian.miit.gov.cn/",
    style: {
      color: '#c7a7a7'
    }
  }, "\u6D59ICP\u590718036064\u53F7"), "\xA0v", constant.version) : /*#__PURE__*/React.createElement("div", {
    style: {
      color: '#c7a7a7'
    }
  }, "\u5206\u8D26\u5B9D \u24D2 Copyright FenZhangBao 2019-2026 \xA0 \u5907\u6848\u53F7:\xA0", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://beian.miit.gov.cn/",
    style: {
      color: '#c7a7a7'
    }
  }, "\u6D59ICP\u59072024094766\u53F7"), "\xA0v", constant.version);
}

export default OemFooter;